<template>
    <div class="shopping-box-view">
        <div class="d-flex p-5 justify-content-center" v-if="loading">
            <app-loading/>
        </div>
        <template v-else>
            <div class="shop-box-header">
                <div class="icon-bag">
                    <span class="fa fa-shopping-bag fa-2x"></span>
                    <span class="qty-total">{{ total_quantity }} Items</span>
                </div>
                <div class="close-btn" @click="toggleCart">
                    <i class="pe-7s-close-circle"></i>
                </div>
            </div>
            <div class="shop-box-body">
                <div class="shop-box-body-inner">
                    <table v-if="carts.length">
                        <tbody>
                        <app-cart-item
                                v-for="cart in carts"
                                :key="cart.id"
                                :cart="cart"
                        />
                        </tbody>
                    </table>
                    <div v-else>
                        <app-no-data-found message="No item found in cart. Continue shopping"/>
                    </div>
                </div>
            </div>
            <div class="shop-box-footer">
                <a href="#" class="order-btn" @click="redirectToCheckOut" v-if="total_quantity > 0">
                    <span class="pull-left">Proceed To Checkout</span>
                    <span class="pull-right">&#2547;{{ Number(total_price).toFixed(2) }}</span>
                </a>
            </div>
        </template>
        <modal name="login-modal" classes="p-5" :adaptive="true" :width="450" height="auto">
            <app-login />
        </modal>
    </div>
</template>

<script>
    import {mapGetters, mapState} from 'vuex'

    export default {
        name: "CartView",
        methods: {
            toggleCart() {
                this.$store.dispatch('setShowCartBox', false);
                this.$store.dispatch('setShowCartBag', true);
            },
            redirectToCheckOut() {
                if (this.isLoggedIn && this.total_quantity > 0) {
                    return window.location = '/checkout'
                }
                this.$modal.show('login-modal')
            }
        },
        computed: {
            ...mapState({
                carts: state => state.cart.carts,
                loading: state => state.loading,
                isLoggedIn: state => state.isLoggedIn,
            }),
            ...mapGetters({
                total_price: 'total_price',
                total_quantity: 'totalQuantity',
            }),
        },
    }
</script>

<style scoped>

</style>